import React from "react";

const Vaspacx = () => {
  return (
    <div className="review">
      <span className="vaspacx">
        <span className="clr-white">vas</span>
        <span className="clr-primary">pac</span>
        <i className="fa fa-xing clr-primary" aria-hidden="true"></i>
        <span className="clr-primary">zilla</span>
      </span>
      <small className="bold-grey-text">
        Here you can find the best gifts for your space lover friend !
      </small>
      <div className="bold-grey-text">
        <i
          className="fa fa-facebook margin-right-5px pointer"
          aria-hidden="true"
        ></i>
        <i
          className="fa fa-twitter margin-right-5px pointer"
          aria-hidden="true"
        ></i>
        <i
          className="fa fa-github margin-right-5px pointer"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  );
};

export default Vaspacx;
